import { render, staticRenderFns } from "./CreateSubResolution.vue?vue&type=template&id=33ee4258&"
import script from "./CreateSubResolution.vue?vue&type=script&lang=js&"
export * from "./CreateSubResolution.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports